import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/auth/authSlice";
import dashboardSlice from "./slices/dashboard/dashboardSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import masterSlice from "./slices/master/masterSlice";
import eligibilitySlice from "./slices/eligibility/eligibilitySlice";

const persistConfig = {
  key: "auth",
  storage,
  stateReconciler: autoMergeLevel2
};

const combinedReducer = combineReducers({
  auth: persistReducer(persistConfig, authReducer),
  dashboard: dashboardSlice,
  master: masterSlice,
  eligibility: eligibilitySlice
});

const rootReducer = (state, action) => {
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});


export const persistor = persistStore(store);
